import AboutPage, { getServerSideProps } from 'pages/[lang]/web-not-available';

export default AboutPage;

export { getServerSideProps };
